import { createReducer } from "redux-act";
import { Record } from "immutable";
import cookie from "react-cookies";
import axios from "axios";

import * as actions from "./actions";

const jwtToken = cookie.load("jwt-token");

const State = Record({
  viewer: null,
  token: jwtToken
});

const reducer = createReducer(
  {
    [actions.signInAction.success]: (state, result) => {
      axios.defaults.headers.common["Authorization"] = `Bearer ${result.data
        .token}`;
      return state.set("token", result.data);
    },
    [actions.signUpAction.success]: (state, result) => {
      return state;
    },
    [actions.refreshTokenAction.success]: (state, result) => {
      return state.set("token", result.data);
    },
    [actions.getCurrentUserAction.success]: (state, result) => {
      return state.set("viewer", result.data);
    }
  },
  new State()
);

export default reducer;



// WEBPACK FOOTER //
// ./src/auth/reducer.js